import React, { useReducer, useRef } from 'react';
import { Link } from 'react-router-dom';

const initialState = {
  title: 'Título inicial',
  buttonLink: 'https://example.com'
};

const actions = {
  UPDATE_TITLE: 'UPDATE_TITLE',
  UPDATE_BUTTON_LINK: 'UPDATE_BUTTON_LINK'
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.UPDATE_TITLE:
      return { ...state, title: action.payload };
    case actions.UPDATE_BUTTON_LINK:
      return { ...state, buttonLink: action.payload };
    default:
      return state;
  }
};

const Button = ({ text, link }) => {
  if (!text) return null; // Si no hay texto, no se renderiza el botón

  return (
    <a href={link}>
      <button className="btn -primary">
        {text}
      </button>
    </a>
  );
};

const DashboardCard = ({ 
  initialTitle, 
  buttonText, 
  initialButtonLink, 
  received, 
  pending, 
  approved, 
  rejected, 
  year, 
  month, 
  profile 
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    title: initialTitle || initialState.title,
    buttonLink: initialButtonLink || initialState.buttonLink
  });

  const titleRef = useRef(null);

  const handleTitleChange = () => {
    dispatch({ type: actions.UPDATE_TITLE, payload: titleRef.current.textContent });
  };


  const handleClick = (profile) => {
    localStorage.setItem('selectedProfile', profile);
  };

  return (
    <div className="card -walnut">
      <div className="row align-items-center">
        <div className="col-12 col-sm-6 col-lg-9">
          <p
            className="h2 mb-0"
            ref={titleRef}
            onBlur={handleTitleChange}
          >
            {initialTitle}
          </p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mt-md-16">
        <Link
          to={state.buttonLink}
          state={{
            year: year,  
            month: month,
            profile: profile,  
          }}
          onClick={() => handleClick(profile)} 
        >
            <Button text={buttonText} />
          </Link>
        </div>
      </div>
      <div className="row mt-24">
        <div className="col-12 col-sm-6 col-lg-3 mt-16">
          <div className="row align-items-center">
            <div className="col-4 pr-0">
              <div className="card -walnut -dark">
                <p className="h3 m-0">{received}</p>
              </div>
            </div>
            <div className="col-8">
              <p className="h3 mb-0">Recibidas</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mt-16">
          <div className="row align-items-center">
            <div className="col-4 pr-0">
              <div className="card -walnut -dark">
                <p className="h3 m-0">{pending}</p>
              </div>
            </div>
            <div className="col-8">
              <p className="h3 mb-0">Pendientes</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mt-16">
          <div className="row align-items-center">
            <div className="col-4 pr-0">
              <div className="card -walnut -dark">
                <p className="h3 m-0">{approved}</p>
              </div>
            </div>
            <div className="col-8">
              <p className="h3 mb-0">Aprobadas</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mt-16">
          <div className="row align-items-center">
            <div className="col-4 pr-0">
              <div className="card -walnut -dark">
                <p className="h3 m-0">{rejected}</p>
              </div>
            </div>
            <div className="col-8">
              <p className="h3 mb-0">Rechazadas</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
